<template>
<!-- 生态宜居·智慧气象·二级页面 -->
  <div>
    <div class="top">
      <div class="t_left">
        <p class="date text-fff">
          {{ homeList.citys }}县 <span>{{ homeList.dates }}</span>
          <span> {{ homeList.week }}</span>
        </p>
        <div class="flex justify-between">
          <div>
            <div style="margin-top: 1rem">
              <img
                v-if="homeList.wea_img == 'xue'"
                :src="weather_img.img_xue"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'lei'"
                :src="weather_img.img_lei"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'shachen'"
                :src="weather_img.img_shachen"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'wu'"
                :src="weather_img.img_wu"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'bingbao'"
                :src="weather_img.img_bingbao"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'yun'"
                :src="weather_img.img_yun"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'yu'"
                :src="weather_img.img_yu"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'yin'"
                :src="weather_img.img_yin"
                alt="#"
              />
              <img
                v-if="homeList.wea_img == 'qing'"
                :src="weather_img.img_qing"
                alt="#"
              />
            </div>
            <p class="duoyun text-fff">{{ homeList.wea }}</p>
          </div>
          <div style="margin-left: 1rem; margin-top: 1rem">
            <p style="font-size: 40px; text-align: left">{{ homeList.tem }}℃</p>
            <p style="line-height: 55px">
              {{ homeList.tem2 }}℃-{{ homeList.tem1 }}℃ {{ homeList.win
              }}{{ homeList.win_speed }}
            </p>
            <p
              style="text-align: left"
              v-if="homeList.alarm_type != '' && homeList.alarm_level != ''"
            >
              <span style="margin-right: 5px">
                <img
                  v-if="homeList.alarm_level == '红色'"
                  :src="yujing_icon.red"
                  alt=""
                />
                <img
                  v-if="homeList.alarm_level == '蓝色'"
                  :src="yujing_icon.blue"
                  alt=""
                />
                <img
                  v-if="homeList.alarm_level == '黄色'"
                  :src="yujing_icon.yellow"
                  alt=""
                />
                <img
                  v-if="homeList.alarm_level == '橙色'"
                  :src="yujing_icon.orange"
                  alt=""
                />
              </span>
              {{ homeList.alarm_type }}{{ homeList.alarm_level }}预警
            </p>
            <p style="text-align: left" v-else>无预警信息</p>
          </div>
        </div>
      </div>
      <div class="t_right">
        <ul>
          <li class="flex">
            <span class="cont_weight">{{ weather_cont_one.cont_one }}</span
            ><span class="cont_weight">{{ weather_cont_one.cont_two }}</span
            ><span class="cont_weight">{{ weather_cont_one.cont_three }}</span>
            <span class="cont_weight">{{ weather_cont_one.cont_four }}</span>
          </li>
          <li class="flex">
            <span class="cont_weight text_size">{{ homeList.air_level }}</span>
            <span class="cont_weight text_size">{{ homeList.humidity }}RH</span>
            <span class="cont_weight text_size"
              >{{ homeList.win }}{{ homeList.win_meter }}</span
            >
            <span class="cont_weight text_size">{{
              homeList.precipitation_num
            }}毫米</span>
          </li>
          <li class="line"></li>
          <li class="flex">
            <span class="cont_weight">{{ weather_cont_two.cont_one }}</span
            ><span class="cont_weight">{{ weather_cont_two.cont_two }}</span
            ><span class="cont_weight">{{ weather_cont_two.cont_three }}</span
            ><span class="cont_weight">{{ weather_cont_two.cont_four }}</span>
          </li>
          <li class="flex">
            <span class="cont_weight text_size"
              >{{ homeList.pressure }}百帕</span
            >
            <span class="cont_weight text_size">{{ homeList.visibility }}</span>
            <span class="cont_weight text_size"
              >{{ homeList.sunrise }}-{{ homeList.sunset }}</span
            >
            <span class="cont_weight text_size"
              >{{ homeList.air_pm25 }}μg/m3</span
            >
          </li>
          <li class="line"></li>
          <li>
            <span class="cont_weight">生活指数</span>
          </li>
          <li class="flex" style="align-items: center;overflow: hidden; ">
            <span class="text_size">穿衣: {{ homeList.indexLevel_1 }} </span>
            <span class="long"></span>
            <span class="text_size">洗车: {{ homeList.indexLevel_2 }} </span>
            <span class="long"></span>
            <span class="text_size">运动: {{ homeList.indexLevel_4 }} </span>
            <span class="long"></span>
            <span class="text_size">紫外线: {{ homeList.indexLevel_3 }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <!-- Swiper -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="flexBox">
              <div
                v-for="(item, index) in SiperList1"
                :key="index"
                style="padding: 20px 0 40px 0"
              >
                <p style="margin: 0">{{ item.date }}</p>
                <p style="margin: 0">{{ item.dateOfWeek }}</p>
                <div>
                  <img
                    v-if="item.day.phrase_img == 'xue'"
                    :src="weather_img.img_xue"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'lei'"
                    :src="weather_img.img_lei"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'shachen'"
                    :src="weather_img.img_shachen"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'wu'"
                    :src="weather_img.img_wu"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'bingbao'"
                    :src="weather_img.img_bingbao"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'yun'"
                    :src="weather_img.img_yun"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'yu'"
                    :src="weather_img.img_yu"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'yin'"
                    :src="weather_img.img_yin"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'qing'"
                    :src="weather_img.img_qing"
                    alt="#"
                    class="hours_img"
                  />
                </div>
                <p style="margin-top: 10px">{{ item.day.phrase }}</p>
              </div>
            </div>
            <div id="echart_weather_one"></div>
          </div>
          <div class="swiper-slide">
            <div class="flexBox">
              <div
                v-for="(item, index) in SiperList2"
                :key="index"
                style="padding: 20px 0 40px 0"
              >
                <p style="margin: 0">{{ item.date }}</p>
                <p style="margin: 0">{{ item.dateOfWeek }}</p>
                <div>
                  <img
                    v-if="item.day.phrase_img == 'xue'"
                    :src="weather_img.img_xue"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'lei'"
                    :src="weather_img.img_lei"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'shachen'"
                    :src="weather_img.img_shachen"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'wu'"
                    :src="weather_img.img_wu"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'bingbao'"
                    :src="weather_img.img_bingbao"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'yun'"
                    :src="weather_img.img_yun"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'yu'"
                    :src="weather_img.img_yu"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'yin'"
                    :src="weather_img.img_yin"
                    alt="#"
                    class="hours_img"
                  />
                  <img
                    v-if="item.day.phrase_img == 'qing'"
                    :src="weather_img.img_qing"
                    alt="#"
                    class="hours_img"
                  />
                </div>
                <p style="margin-top: 10px">{{ item.day.phrase }}</p>
              </div>
            </div>
            <div id="echart_weather_two"></div>
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
    <p class="text-center">数据来源：{{Data_txt}}</p>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { number } from "echarts";
export default {
  components: {},
  props: {},
  data() {
    return {
      Data_txt:'',
      // 天气预报数据当天
      homeList: {
        dates: "",
        citys: "",
        wea: "",
        tem: "",
        tem1: "",
        tem2: "",
        week: "",
        win: "",
        win_speed: "",
        air_level: "",
        humidity: "",
        win_meter: "",
        pressure: "",
        visibility: "",
        air_pm25: "",
        air_tips: "",
        sunrise: "",
        sunset: "",
        indexLevel_1: "",
        indexLevel_2: "",
        indexLevel_3: "",
        indexLevel_4: "",
        alarm_type: "",
        alarm_level: "",
        wea_img: "",
        //降雨量
        precipitation_num: 0,
      },
      yujing_icon: {
        orange: require("@/assets/images/chengse.png"),
        red: require("@/assets/images/hongse.png"),
        blue: require("@/assets/images/lanse.png"),
        yellow: require("@/assets/images/huangse.png"),
      },
      weather_cont_one: {
        cont_one: "空气质量",
        cont_two: "空气湿度",
        cont_three: "风",
        cont_four: "降雨量",
      },
      weather_cont_two: {
        cont_one: "气压",
        cont_two: "能见度",
        cont_three: "日出日落",
        cont_four: "PM2.5",
      },
      // 天气预报未来15天
      SiperList1: [],
      SiperList2: [],
      zuigao: [],
      zuidi: [],
      zuigao1: [],
      zuidi1: [],
      today: [],
      // 天气图片
      weather_img: {
        img_xue: require("@/assets/images/xue.png"),
        img_lei: require("@/assets/images/lei.png"),
        img_shachen: require("@/assets/images/shachen.png"),
        img_wu: require("@/assets/images/wu.png"),
        img_bingbao: require("@/assets/images/bingbao.png"),
        img_yun: require("@/assets/images/yun.png"),
        img_yu: require("@/assets/images/yu.png"),
        img_yin: require("@/assets/images/yin.png"),
        img_qing: require("@/assets/images/qing.png"),
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 天气预报当天
    weather() {
      var weatherList = plOtherDataInterface.getTodayWeather();
      this.homeList.citys = weatherList.city;
      this.homeList.dates = weatherList.date;
      this.homeList.wea = weatherList.wea;
      this.homeList.wea_img = weatherList.wea_img;
      this.homeList.tem = weatherList.tem;
      this.homeList.tem1 = weatherList.tem1;
      this.homeList.tem2 = weatherList.tem2;
      this.homeList.week = weatherList.week;
      this.homeList.win = weatherList.win;
      this.homeList.win_speed = weatherList.win_speed;
      this.homeList.air_level = weatherList.air_level;
      this.homeList.humidity = weatherList.humidity;
      this.homeList.win_meter = weatherList.win_meter;
      this.homeList.pressure = weatherList.pressure;
      this.homeList.visibility = weatherList.visibility;
      this.homeList.air_pm25 = weatherList.air_pm25;
      this.homeList.air_tips = weatherList.air_tips;
      this.homeList.sunrise = weatherList.sunrise;
      this.homeList.sunset = weatherList.sunset;
      this.homeList.indexLevel_1 = weatherList.zhishu.chuanyi.level;
      this.homeList.indexLevel_2 = weatherList.zhishu.xiche.level;
      this.homeList.indexLevel_3 = weatherList.zhishu.ziwaixian.level;
      this.homeList.indexLevel_4 = weatherList.aqi.yundong;
      this.homeList.alarm_type = weatherList.alarm.alarm_type;
      this.homeList.alarm_level = weatherList.alarm.alarm_level;
    },
    // 天气预报15天
    moreWeather() {
      var moreList = plOtherDataInterface.getMoreWeather();
      console.log(moreList);
      var arr = moreList.month;
      var NewArr = arr.slice(1, 8);
      this.SiperList1 = NewArr;
      var NewArr2 = arr.slice(8, 15);
      this.SiperList2 = NewArr2;
    },
    // 降雨量
    precipitation() {
      var data = plOtherDataInterface.getPrecipitation();
      var arr = data.data.map((item) => item.value);
      var numArr = arr.map(Number);
      var sum = 0;
      numArr.forEach((ele) => {
        sum += ele;
      });
     this.homeList.precipitation_num = sum.toFixed(2)
    },
    // 轮播
    swiper() {
      var swiper = new Swiper(".swiper-container", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    // 未来15天 天气折线图
    init_one() {
      var weatherList = plOtherDataInterface.getMoreWeather();
      console.log(weatherList);
      var arr = weatherList.month;
      var NewArr = arr.slice(1, 8);
      this.today = NewArr.map((item) => item.dateOfWeek);
      var dayArr = NewArr.map((item) => item.day);
      this.zuigao = dayArr.map((item) => item.temperature);
      var nightArr = NewArr.map((item) => item.night);
      this.zuidi = nightArr.map((item) => item.temperature);
      var myChart = echarts.init(document.getElementById("echart_weather_one"));
      var option = {
        color: ["#F97555", "#82CCFF"],
        grid: {
          x: 5,
          x2: 5,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          data: this.today,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        series: [
          {
            name: "最高气温",
            data: this.zuigao,
            type: "line",
            label: {
              show: true,
              position: "top",
              color: "#3EF89C",
              formatter: "{c}°C",
            },
          },
          {
            name: "最低气温",
            data: this.zuidi,
            type: "line",
            label: {
              show: true,
              position: "bottom",
              color: "#3EF89C",
              formatter: "{c}°C",
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },

    init_two() {
      var weatherList = plOtherDataInterface.getMoreWeather();
      var arr = weatherList.month;
      var NewArr = arr.slice(8, 15);
      var dayArr = NewArr.map((item) => item.day);
      this.zuigao1 = dayArr.map((item) => item.temperature);
      var nightArr = NewArr.map((item) => item.night);
      this.zuidi1 = nightArr.map((item) => item.temperature);
      var myChart = echarts.init(document.getElementById("echart_weather_two"));
      var option = {
        color: ["#F97555", "#82CCFF"],
        grid: {
          x: 5,
          x2: 5,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          data: this.today,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        series: [
          {
            name: "最高气温",
            data: this.zuigao1,
            type: "line",
            label: {
              show: true,
              position: "top",
              color: "#3EF89C",
              formatter: "{c}°C",
            },
          },
          {
            name: "最低气温",
            data: this.zuidi1,
            type: "line",
            label: {
              show: true,
              position: "bottom",
              color: "#3EF89C",
              formatter: "{c}°C",
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 数据来源
    Sources(){
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[3].weather;
    }
  },
  created() {},
  mounted() {
    this.swiper();
    this.init_one();
    this.init_two();
    this.weather();
    this.moreWeather();
    this.precipitation();
    this.Sources();
  },
};
</script>
<style lang="less" scoped>
.top {
  color: #fff;
  display: flex;
  justify-content: space-between;
  .date {
    font-size: 18px;
  }
  .duoyun {
    margin-top: 10px;
    font-size: 20px;
  }
  .t_left {
    width: 35%;
  }
  .t_right {
    width: 65%;
    color: #fff;
    overflow: hidden;
  }
}
.flex {
  display: flex;
}
.line {
  height: 1px;
  background: #fff;
  margin: 10px 0;
}
.justify-between {
  justify-content: center;
}
p,
ul {
  margin-block-start: 0;
  margin-block-end: 0;
}
li {
  list-style: none;
  text-align: left;
  line-height: 30px;
}
.flex {
  display: flex;
  justify-content: space-around;
}
.flex span {
  display: inline-block;
}
.cont_weight {
  width: 25%;
}
.long {
  width: 2px;
  display: inline-block;
  height: 0.875rem;
  background: #fff;
}
.swiper-container {
  width: 100%;
  margin: .75rem 0;
  padding: 8px 0;
  height: 100%;
  background: #03333c;
}
.swiper-slide {
  width: 100%;
  background: #03333c;
  text-align: center;
  font-size: 16px;
  color: #fff;
}
.swiper-button-next,
.swiper-button-prev {
  width: 25px;
  height: 52px;
  background: rgba(18, 87, 123, 0.6);
  color: #fff;
}
.swiper-button-next {
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.swiper-button-prev {
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.text-green {
  font-size: 16px;
  color: #3ef89c;
  margin: 0;
}
.flexBox {
  width: 97%;
  padding: 0 40px;
  display: flex;
  justify-content: space-around;
  .hours_img {
    width: 65px;
    height: 60px;
    margin-top: 20px;
  }
}
#echart_weather_one,
#echart_weather_two {
  width: 100%;
  height: 100px;
}
.text_size {
  font-size: 18px;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
/deep/ .swiper-button-next:after, .swiper-button-prev:after{
font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/weather/weather.vue